import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import sourceflowEnums from "@/sourceflow.enums";

import { router } from "@/routes";


export { default } from 'pages/blog'


export async function getStaticProps() {
    const global = (await Global()).toJson();

    const blogs = (await Collection(`reviews`))
        .filter(post => {
            // Reviews value id
            return post?.blog_category.en.includes("b35b49e3-8bee-42f0-bc91-aa5076e43ae9");
        })
        .orderBy(['published_date.en'], ['desc'])
        .getItems()
    const blog_tags = (await Collection(`blog_tags`)).getItems()
    const blog_category = (await Collection(`blog_category`)).getItems()

    const routerKey = "reviews";

    return {
        props: {
            global,
            blogs,
            blog_category,
            blog_tags,
            meta: {
                title: "Reviews | Tradewind Subs",
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            },
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search